import Component from '@glimmer/component';

import SkeletonScreenComponent from 'webapp/components/skeleton-screen';

export default class TeamsIndexLoadingRouteTemplate extends Component {
	skeletonScreenType = 'tiles';

	<template><SkeletonScreenComponent @type={{this.skeletonScreenType}} @item="team" /></template>
}
